import HotelListCardMini from './HotelListCardMini';

export default HotelListCardMini;
